export interface ComboUser {
  uuid: string;
  name?: string | null;
  email?: string | null;
}

// `query` must already be trimmed and lower-cased; empty matches everyone.
export const user_matches = (u: ComboUser, query: string): boolean =>
  !query ||
  (u.name || '').toLowerCase().includes(query) ||
  (u.email || '').toLowerCase().includes(query);

export { default as normalize_query } from '../search_combobox/normalize_query';

export const user_option_label = (u: ComboUser): string => {
  const name = u.name || u.email || u.uuid;
  return u.email && u.email !== name ? `${name} (${u.email})` : name;
};
